export default [
  'unit',
  'frequency',
  'status',
  'startDuration',
  'startUnit',
  'endDuration',
  'endUnit',
  'pricingModel',
  'transactionType',
  'minimumQuantity',
  'maximumQuantity',
  'salesChannel',
  'marketSegment',
  'accountType',
  'accountSubType',
  'serviceType',
  'index',
  'refIndex',
  'amount',
  'isQuantityScalable',
  'cancelProration',
  'purchaseProration',
  'purchaseProration',
  'upgradeProration',
  'downgradeProration',
  'tierType',
  'tierReference',
  'volumeTreatment',
  'evaluationStart',
  'evaluationEnd',
  'offsetMonths',
  'nextPricingTerm',
  'maximum',
  'minimum',
  'grantDuration',
  'grantUnit',
  'duration',
  'timeUnit',
  'pricingType',
  'applyInAdvance',
  'omsTaskType',
  'isProvisionable',
  'flatRate',
  'ratingTimeTaxation',
  'offerNameAsTxnDescr',
  'rateWhenInactive',
];
